<template>
  <div id="pageCadastroLinha">
    <v-container grid-list-x2 fluid>
      <v-layout row wrap justify-center>
        <v-flex lg6 sm12 xs12>
          <v-card>
            <v-toolbar color="pink" dark flat dense cad>
              <v-toolbar-title v-if="this.id" class="subheading">Editar linha</v-toolbar-title>
              <v-toolbar-title v-else class="subheading">Nova linha</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="">
              <linha-form></linha-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import LinhaForm from "@/components/linha/formLinha"
export default {
  components: {
    LinhaForm
  },
  data: () => ({
    id: null
  }),
  created() {
    if (this.$route && this.$route.params) {
      this.id = this.$route.params.id
    }
  }
}
</script>
